<template>  
    <router-view></router-view>  
</template>

<style lang="less">
	@import './style/main.less';
</style>
<script>
	export default {
		created () {
		
		},
		methods:{
			tokenLogin(token){
				this.$http.post('tklogin',
		          {token:token}
		          )
		        .then(response=>{
		          Auth.setLocalLogin(response.body.data)
		          //this.$router.push({ path: '/' })
		        },response=>{
	              this.loading = false
	              let msg = response.body.message
	              let msg_map = {
	                'captcha_error':'验证码错误',
	                'password_is_wrong':'密码错误',
	                'account_does_not_exists':'账号不存在',
	                'user_is_disabled':'账号被禁用',
	                'client_time_not_correct':'您的电脑系统日期不对,请先将电脑日期设置正确!'
	              }
	              msg = msg_map[msg]?msg_map[msg]:msg;
	              if(response.body.message == 'captcha_error'){
	                  this.focus('captcha')
	              }else if(response.body.message == 'password_is_wrong'){
	                  this.focus('password') 
	              }else if(response.body.message == 'account_does_not_exists'){
	                  this.focus('account')
	              }
	              //this.refreshCaptcha()
	              this.$Message.error(msg)
		        })
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/App.vue